import { OneOfElements } from '@shared/models/project.model';
import { projectGuards } from '../../guards/project-guards.helpers';
import { ProjectChangeType } from '../update-engine.models';
import type { ProjectChangeMap } from '../update-engine.models';

type ElementActivateChange =
  ProjectChangeMap[ProjectChangeType.ElementActivate];

/**
 * Set {@link IElement.isDeactivated} to false (visible in proposal / baseline).
 *
 * @param element - Current element state
 * @param change - Activate payload
 * @returns Partial element or undefined when not an {@link ElementKind.Element} or already active
 */
export const elementActivateToChange = (
  element: OneOfElements,
  _change: ElementActivateChange,
): Partial<OneOfElements> | undefined => {
  if (!projectGuards.is.element(element)) return undefined;
  // Already visible: undefined or explicit false
  if (element.isDeactivated !== true) return undefined;

  return { isDeactivated: false };
};
